/* eslint-disable no-magic-numbers */
import { Component, EventEmitter, Inject, inject, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { NGX_MAT_DATE_FORMATS } from '@ngxmc/datetime-picker';
import {
  CCOMX_MAT_DATE_FORMATS,
  DATE_WITH_TIME_DISPLAY,
  USE_DATE_TIME_FORMAT,
} from '../../../core/ccomx-date-formats';
import { dirtyOrTouchedErrorStateMatcher } from '../../constants/dirty-or-touched-error-state-matcher';
import { validationMessages } from '../../messages';

@Component({
  selector: 'app-shared-ui-datepicker',
  templateUrl: './ui-datepicker.component.html',
  styleUrls: ['./ui-datepicker.component.scss'],
  providers: [
    {
      provide: MAT_DATE_FORMATS,
      useFactory: () => {
        return inject(USE_DATE_TIME_FORMAT) ? DATE_WITH_TIME_DISPLAY : CCOMX_MAT_DATE_FORMATS;
      },
    },
    {
      provide: NGX_MAT_DATE_FORMATS,
      useValue: DATE_WITH_TIME_DISPLAY,
    },
  ],
  standalone: false,
})
export class UiDatepickerComponent {
  readonly errorStateMatcher = dirtyOrTouchedErrorStateMatcher;

  @Input() label = '';
  @Input() description = '';
  @Input() control: FormControl;
  @Input() placeholder: string;
  @Input() messages = validationMessages;
  @Input() omitErrorKeys: string[] = [];
  @Input() required = true;
  @Input() selected: boolean;
  @Input() min: Date | null;
  @Input() max: Date | null;
  @Input() initialTime: number[];
  @Input() tabIndex = 0;
  @Input() subscriptSizing: 'fixed' | 'dynamic' | '' = '';

  @Output() readonly changeHandler: EventEmitter<any> = new EventEmitter<any>();

  constructor(@Inject(USE_DATE_TIME_FORMAT) public useDateTimeFormat: boolean) {
    const date = new Date();
    this.initialTime = [date.getHours(), date.getMinutes(), date.getSeconds()];
  }

  setOpenedDate(datePicker: any): void {
    // fix for a bug in the datepicker https://github.com/h2qutc/angular-material-components/issues/356
    const value = this.getOpenedDate();
    this.control.setValue(value);
    // eslint-disable-next-line no-underscore-dangle
    datePicker._selected = value;
    datePicker.startAt = value;
  }

  private getOpenedDate(): Date {
    if (this.control.value) {
      return this.control.value;
    }

    const fallback = new Date();
    fallback.setHours(this.initialTime[0], this.initialTime[1], this.initialTime[2]);
    return this.clampToMinMax(fallback);
  }

  private clampToMinMax(value: Date): Date {
    if (this.min && value < this.min) {
      return new Date(this.min.getTime());
    }
    if (this.max && value > this.max) {
      return new Date(this.max.getTime());
    }
    return value;
  }
}
